import { Component, Inject } from '@angular/core';
import { AuthService } from '@asp/authentication';
import { TuiAlertService } from '@taiga-ui/core';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
})
export class SignInComponent {
  email: string;
  password: string;

  constructor(
    private auth: AuthService,
    @Inject(TuiAlertService) private readonly alerts: TuiAlertService,
  ) {}

  login() {
    if (this.email && this.password) {
      this.auth
        .login(this.email, this.password)
        .pipe()
        .subscribe(
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          () => {},
          () => {
            this.email = undefined;
            this.password = undefined;
            this.alerts
              .open($localize`Wrong email or password!`, {
                label: $localize`Authentication Failed`,
                status: 'error',
              })
              .subscribe();
          },
        );
    } else {
      this.alerts
        .open($localize`Please provide valid email and password!`, {
          label: $localize`Invalid Credentials`,
          status: 'error',
        })
        .subscribe();
    }
  }
}
